import React from 'react';
import styled from '@emotion/native';
import { TouchableOpacity, Image, Linking } from 'react-native';
import AppleLogo from '../../assets/images/Apple.png';
import { green, sand, secondaryHover } from '@/shared/styles/colors';
import { BodyText } from '@/shared/components/StyledText';
import { EMME_APP_STORE_URL, IS_WEB } from '@/shared/constants/utility';
import { useWebHoverToggle } from '@/shared/hooks/useWebHoverToggle';
import { FONT_STYLES, WELCOME_CTA_MAX_WIDTH } from '@/shared/styles/constants';

interface WelcomeButtonProps {
  marginBottom?: number;
  alignSelf?: 'center' | 'flex-start' | 'flex-end' | 'stretch';
}

const WelcomeButton = ({
  marginBottom = 41,
  alignSelf = 'center',
}: WelcomeButtonProps) => {
  const { isHovered, webHoverProps } = useWebHoverToggle();

  const handlePress = () => {
    Linking.openURL(EMME_APP_STORE_URL);
  };

  return (
    <StyledButton
      onPress={handlePress}
      marginBottom={marginBottom}
      alignSelf={alignSelf}
      {...webHoverProps}
      style={
        IS_WEB && isHovered ? { backgroundColor: secondaryHover } : undefined
      }
    >
      <Logo source={AppleLogo} />
      <TextContainer>
        <SmallText>Download on the</SmallText>
        <LargeText>App Store</LargeText>
      </TextContainer>
    </StyledButton>
  );
};

const StyledButton = styled(TouchableOpacity)<
  Required<Pick<WelcomeButtonProps, 'marginBottom' | 'alignSelf'>>
>(({ marginBottom, alignSelf }) => ({
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'center',
  borderRadius: 175,
  width: '100%',
  maxWidth: WELCOME_CTA_MAX_WIDTH,
  alignSelf,
  height: 71,
  backgroundColor: sand,
  marginBottom,
  paddingTop: 17,
}));

const Logo = styled(Image)({
  width: 26,
  height: 31,
  resizeMode: 'contain',
  marginRight: 12,
});

const TextContainer = styled.View({
  flexDirection: 'column',
});

const SmallText = styled(BodyText)({
  ...FONT_STYLES.welcomeHelveticaNeue,
  color: green,
  fontSize: 11,
  lineHeight: 12,
  marginBottom: 2,
  letterSpacing: 1,
});

const LargeText = styled(SmallText)({
  fontWeight: 600,
  fontSize: 22,
  lineHeight: 20,
  letterSpacing: -0.05,
});

export default WelcomeButton;
